<h1>New Organisation</h1>

<div fxLayout="row">

  <div fxFlex="0 1 50%">
    <organisation-form [loading]="loading | async"
      [mode]="formMode"
      (submitted)="submitOrg($event)"></organisation-form>

  </div>

</div>